"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearTemplates = exports.loadTemplatesFail = exports.loadTemplatesSuccess = exports.loadTemplatesRequest = void 0;

var _templates = require("./templates.types");

var loadTemplatesRequest = function loadTemplatesRequest(giftId) {
  return {
    type: _templates.GIFT_CREATE_LOAD_TEMPLATES_REQUEST,
    payload: giftId
  };
};

exports.loadTemplatesRequest = loadTemplatesRequest;

var loadTemplatesSuccess = function loadTemplatesSuccess(templates) {
  return {
    type: _templates.GIFT_CREATE_LOAD_TEMPLATES_SUCCESS,
    payload: templates
  };
};

exports.loadTemplatesSuccess = loadTemplatesSuccess;

var loadTemplatesFail = function loadTemplatesFail(error) {
  return {
    type: _templates.GIFT_CREATE_LOAD_TEMPLATES_FAIL,
    payload: error
  };
};

exports.loadTemplatesFail = loadTemplatesFail;

var clearTemplates = function clearTemplates() {
  return {
    type: _templates.GIFT_CREATE_CLEAR_TEMPLATES
  };
};

exports.clearTemplates = clearTemplates;